import { State } from '../../types';

export const utah: State = {
  name: 'Utah',
  abbreviation: 'UT',
  terms: [
    {
      word: 'Duchesne',
      phonetic: 'Doo-shayne',
      // audioUrl: '/audio/hurricane.mp3',
      description: 'A small alpine city in Utah.'
    },
    {
      word: 'Creosote',
      phonetic: 'KREE-uh-soht',
      description: 'The creosote bush, common in Southwestern deserts. Often mispronounced as "KREE-oh-soht."'
    },
    {
      word: 'Hurricane',
      phonetic: 'HER-uh-kun',
      // audioUrl: '/audio/hurricane.mp3',
      description: 'A city in Washington County, pronounced as "HER-uh-kun," not like the tropical storm.'
    },
    {
      word: 'Juab',
      phonetic: 'JOO-ab',
      // audioUrl: '/audio/juab.mp3',
      description: 'A county in central Utah, derived from a Paiute word meaning "flat plain."'
    },
    {
      word: 'Kanab',
      phonetic: 'kuh-NAB',
      // audioUrl: '/audio/kanab.mp3',
      description: 'A city in southern Utah, named after a Paiute word for "willow."'
    },
    {
      word: 'Kamas',
      phonetic: 'KAM-uss',
      // audioUrl: '/audio/kamas.mp3',
      description: 'A city in Summit County, named after an edible wild bulb.'
    },
    {
      word: 'Mantua',
      phonetic: 'MAN-uh-way',
      // audioUrl: '/audio/mantua.mp3',
      description: 'A town in Box Elder County, pronounced as "MAN-uh-way," differing from the Italian city.'
    },
    {
      word: 'Moab',
      phonetic: 'MO-ab',
      // audioUrl: '/audio/moab.mp3',
      description: 'A city in eastern Utah, possibly named after the biblical land of Moab or from the Paiute word "moapa," meaning "mosquitoes."'
    },
    {
      word: 'Nephi',
      phonetic: 'NEE-fy',
      // audioUrl: '/audio/nephi.mp3',
      description: 'A city in Juab County, named after a prophet in the Book of Mormon.'
    },
    {
      word: 'Oquirrh',
      phonetic: 'OH-kur',
      // audioUrl: '/audio/oquirrh.mp3',
      description: 'A mountain range in northern Utah, named from the Goshute word meaning "wooded mountain."'
    },
    {
      word: 'Tooele',
      phonetic: 'too-ILL-uh',
      // audioUrl: '/audio/tooele.mp3',
      description: 'A city and county in northwestern Utah, pronounced as "too-ILL-uh," not as it appears.'
    },
    {
      word: 'Toquerville',
      phonetic: 'TOH-kur-vil',
      // audioUrl: '/audio/toquerville.mp3',
      description: 'A town in Washington County, named after Paiute Chief Toquer.'
    },
    {
      word: 'Uintah',
      phonetic: 'you-IN-tah',
      // audioUrl: '/audio/uintah.mp3',
      description: 'A county and mountain range in northeastern Utah, named from the Ute word for "pine land."'
    },
    {
      word: 'Weber',
      phonetic: 'WEE-ber',
      // audioUrl: '/audio/weber.mp3',
      description: 'A county and river in northern Utah, pronounced as "WEE-ber," not "WEB-er."'
    }
  ]
};